import React from 'react';
import b_ from 'b_';
import I18N from 'assets/i18n/brandlift-project';

import BlockInput from 'client/common/components/block-input';
import {SelectWithTags} from 'client/common/components/lego';
import AgeSlider from 'client/common/components/age-slider';
import {
    convertToLegoOptions,
    filterCountryRegionsChangeOnCountrySelect,
    TargetingOptionsType
} from 'client/common/components/audience-settings/helpers';
import {AgeCategory, AudienceCategoryValue, GenderCategory} from 'client/common/types';

const b = b_.with('audience-settings');
const i18n = I18N.common.audienceSettings.audienceTargeting;

interface TargetingCategoriesProps {
    disabled?: boolean;
    handleAgeSelect: (value: AgeCategory['value']) => void;
    handleGenderSelect: (value: GenderCategory['value']) => void;
    handleGeoSelect: (value: AudienceCategoryValue[]) => void;
    isCreativeBox?: boolean;
    selectedAge: string[];
    selectedGender: GenderCategory['value'];
    selectedGeo: string[];
    selectedGeoValue: AudienceCategoryValue[];
    targetingOptions: TargetingOptionsType;
}

export default function TargetingCategories(props: TargetingCategoriesProps) {
    const {
        disabled,
        handleAgeSelect,
        handleGenderSelect,
        handleGeoSelect,
        isCreativeBox,
        selectedAge,
        selectedGender,
        selectedGeo,
        selectedGeoValue,
        targetingOptions
    } = props;

    return (
        <>
            {!isCreativeBox && targetingOptions.geo.length > 1 && (
                <BlockInput title={i18n.citiesTitle}>
                    <SelectWithTags
                        onChange={e => {
                            filterCountryRegionsChangeOnCountrySelect(
                                selectedGeo,
                                handleGeoSelect
                            )(e.target.value);
                        }}
                        options={convertToLegoOptions(targetingOptions.geo)}
                        value={selectedGeoValue}
                        size='m'
                        disabled={disabled}
                        minSelected={1}
                        width='max'
                        view='dl-clear'
                    />
                </BlockInput>
            )}
            <div className={b('audience-type-wrapper', {type: 'gender'})}>
                <BlockInput title={i18n.genderTitle}>
                    <SelectWithTags
                        onChange={e => handleGenderSelect(e.target.value)}
                        options={convertToLegoOptions(targetingOptions.gender)}
                        value={selectedGender}
                        size='m'
                        disabled={disabled}
                        minSelected={1}
                        width='max'
                        view='dl-clear'
                    />
                </BlockInput>
                <BlockInput title={i18n.ageTitle}>
                    <AgeSlider
                        age={selectedAge}
                        disabled={Boolean(disabled)}
                        onChange={handleAgeSelect}
                    />
                </BlockInput>
            </div>
        </>
    );
}
